// Adobe Analytics Helper functions
import {siteTierConfig} from '../app.config';
import {store} from '../configureStore';
import {getLdUserExperimentName} from './';
import { getUserEntitlementLevel, getIsPowerUser } from '@adsk/ha-entitlements-util';

export const initAnalytics = () => {
  window.__analyticsChangeContext = window.__analyticsChangeContext || [];
};


// set values
export const setAdobeAnalyticsValue = (
  eventType = 'page_view',
  contentDescription = '',
  pageType = '',
  branchName = '',
  transactionPlatform = '',
  transactionType = 'waf - uhm',
  transactionSubType = 'standard',
  languageCode = ''
) => {
  let getStore = store.getState();
  let {userEntitlements, loginHappening = false} = getStore.userData;

  const entitlement = getUserEntitlementLevel(userEntitlements);
  const isPowerUser = getIsPowerUser(entitlement);

  const aknUserRole = `${entitlement}${isPowerUser ? ' - Power User' : ''}`;
  /*
   * Prevents triggering event with incorrect user entitlement
   * while logging still in progress
   */
  if (loginHappening) {
    setTimeout(() => {
      setAdobeAnalyticsValue(
        eventType,
        contentDescription,
        pageType,
        branchName,
        transactionPlatform,
        transactionType,
        transactionSubType,
        languageCode
      );
    }, 3000);

    return;
  }

  window.__analyticsChangeContext = window.__analyticsChangeContext || [];
  let contentDescSplit = contentDescription.split(':');
  let useContentSplit = contentDescSplit[0];
  let tmpAnalyticsData = {
    event: {
      eventType: eventType,
    },
    page: {
      contentDescription: useContentSplit.trim(), // a unique string representing the "step" in the workflow / funnel
      pageType: pageType,
      siteSection: 'uhm',
      languageCode: languageCode,
    },
    branch: {
      branchName: branchName,
    },
    transaction: {
      transactionPlatform: transactionPlatform,
      transactionType: transactionType,
      transactionSubType: transactionSubType,
    },
    user: {
      aknUserRole,
      launchExperiment: getLdUserExperimentName(),
    },
  };
  if (contentDescSplit[1]) {
    tmpAnalyticsData.page.subSection1 = contentDescSplit[1].trim();
  } else {
    tmpAnalyticsData.page.subSection1 = '';
  }
  if (contentDescSplit[2]) {
    tmpAnalyticsData.page.subSection2 = contentDescSplit[2].trim();
  } else {
    tmpAnalyticsData.page.subSection2 = '';
  }

  window.__analyticsChangeContext.push(tmpAnalyticsData);

  console.log('tmpAnalyticsData:');
  console.log(tmpAnalyticsData);
};

export const appendAnalyticsParamsToLink = (url, utmSource) => {
  let queryString = [];
  let hashParam = url && url.match(/#(.+)/) ? url.match(/#(.+)/)[0] : '';
  let cleanedUrl = url && url.replace(/#(.+)/, '');

  // get mktvar004
  if (
    typeof siteTierConfig.cmtVar !== 'undefined' &&
    siteTierConfig.cmtVar.length
  )
    queryString.push(`mktvar004=${siteTierConfig.cmtVar}`);
  // get ut paramters
  if (typeof utmSource !== 'undefined' && utmSource.length)
    queryString.push(`utm_source=${utmSource}&utm_medium=referral`);

  if (queryString.length === 0) return url;

  let isQuestionMarkPresent = cleanedUrl && cleanedUrl.indexOf('?') !== -1,
    separator = isQuestionMarkPresent ? '&' : '?';
  cleanedUrl += separator + queryString.join('&') + hashParam;

  return cleanedUrl;
};
